const getEnv = (key, fallback) => {
    if (typeof process !== 'undefined' && process.env[key]) {
        return process.env[key];
    }
    return fallback;
};
/**
 * Central environment configuration for all pondlogs packages.
 * Values are injected at build time via webpack EnvironmentPlugin,
 * with the listed defaults used in development.
 */
export const env = {
    /** Base URL of the pondlogs V3 BFF.
     * Defaults to '' so all API calls use relative paths and are proxied by nginx.
     * Set PONDLOGS_API_URL only when calling the BFF directly (e.g. local dev without nginx). */
    apiBaseUrl: getEnv('PONDLOGS_API_URL', ''),
    // Legacy fallback kept for direct BFF access outside nginx: http://localhost:3001
    /** Relative auth sign-in API path. */
    authSignInPath: getEnv('PONDLOGS_AUTH_SIGNIN_PATH', '/api/v3/auth/signin'),
    /** Relative auth sign-up API path. */
    authSignUpPath: getEnv('PONDLOGS_AUTH_SIGNUP_PATH', '/api/v3/auth/signup'),
    /** Relative auth sign-out API path. */
    authSignOutPath: getEnv('PONDLOGS_AUTH_SIGNOUT_PATH', '/api/v3/auth/signout'),
    /** Relative forgot-password API path. */
    forgotPasswordPath: getEnv('PONDLOGS_FORGOT_PASSWORD_PATH', '/api/v3/auth/forgot-password'),
    /** Relative CSRF token API path (unused in V3 BFF — skipped automatically). */
    csrfTokenPath: getEnv('PONDLOGS_CSRF_TOKEN_PATH', '/api/v3/csrf-token'),
    /** Relative global config API path. */
    globalConfigPath: getEnv('PONDLOGS_GLOBAL_CONFIG_PATH', '/api/v3/global-config'),
    /** Relative agreement acceptance API path. */
    agreementAcceptPath: getEnv('PONDLOGS_AGREEMENT_ACCEPT_PATH', '/api/v3/auth/accept-agreement'),
    /** Cloudflare Turnstile public site key. */
    captchaSiteKey: getEnv('PONDLOGS_CAPTCHA_SITE_KEY', '0x4AAAAAABiV3EMD0NaZwt89'),
    /** Display name of the application. */
    appName: getEnv('PONDLOGS_APP_NAME', 'Eruvaka Technologies'),
    /** localStorage key used to persist the auth session. */
    sessionStorageKey: 'pondlogs_session',
    /** Google Maps JavaScript API key (for maps, drawing, geometry, places libraries). */
    googleMapsApiKey: getEnv('PONDLOGS_GOOGLE_MAPS_API_KEY', 'AIzaSyBSzykUt6G-o9KCBqZFJLiC3v8rVfsABAs'),
    /** Google Maps Static/Imagery API key. */
    googleMapsImageApiKey: getEnv('PONDLOGS_GOOGLE_MAPS_IMAGE_API_KEY', 'AIzaSyDf-4_1HCDClZCXzpbdxpQl6ptGbznLP8k'),
};
